import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InputGroupComponent } from './inputGroup.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path:'',
				component: InputGroupComponent
			}
		])
	],
	exports: [
		RouterModule
	]
})
export class InputRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/view/inputGroup/input-routing.module.ts